const newArea = {
  snackbar: "Su actualización esta completada",
  name: "Nombre de Área",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Área",
  formTitle: "Nueva Área",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar",
  selectPlant: "Selecciona un Edificio",
  selectCompany: "Selecciona una Compañía"
};
export default newArea;
